import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'
import { Color } from '../color/Color'

export enum GiftVoucherStatusId {
  PAID = 'paid',
  UNPAID = 'unpaid',
  ASSIGNED = 'assigned',
  USED = 'used',
  EXPIRED = 'expired',
}

export class GiftVoucherStatus extends Codebook<GiftVoucherStatusId> {
  static readonly PAID = new GiftVoucherStatus(
    GiftVoucherStatusId.PAID,
    () => $t('Paid'),
    Color.INFO,
  )
  static readonly UNPAID = new GiftVoucherStatus(
    GiftVoucherStatusId.UNPAID,
    () => $t('Unpaid'),
    Color.NEGATIVE,
  )
  static readonly ASSIGNED = new GiftVoucherStatus(
    GiftVoucherStatusId.ASSIGNED,
    () => $t('Assigned'),
    Color.POSITIVE,
  )
  static readonly USED = new GiftVoucherStatus(
    GiftVoucherStatusId.USED,
    () => $t('Used'),
    Color.WARNING,
  )
  static readonly EXPIRED = new GiftVoucherStatus(
    GiftVoucherStatusId.EXPIRED,
    () => $t('Expired'),
    Color.NEGATIVE,
  )

  private constructor(
    id: GiftVoucherStatusId,
    public readonly name: () => string,
    public readonly color: Color.INFO | Color.NEGATIVE | Color.POSITIVE | Color.WARNING,
  ) {
    super(id)
  }
}
